"use client";

import { c as _c } from "react/compiler-runtime";
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from "lucide-react";
import { useMobileSize } from "@repo/common/hooks/use-mobile-size";
import { useTheme } from "next-themes";
import { Toaster as Sonner, type ToasterProps, toast } from "sonner";
type Props = ToasterProps & {
  useCrmToastDefaults?: boolean;
};
function BaseToaster(props) {
  const $ = _c(5);
  const {
    theme: t0
  } = useTheme();
  const theme = t0 === undefined ? "system" : t0;
  const t1 = theme as ToasterProps["theme"];
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      success: <CircleCheckIcon className="size-4" />,
      info: <InfoIcon className="size-4" />,
      warning: <TriangleAlertIcon className="size-4" />,
      error: <OctagonXIcon className="size-4" />,
      loading: <Loader2Icon className="size-4 animate-spin" />
    };
    t3 = {
      "--normal-bg": "hsl(var(--background))",
      "--normal-text": "hsl(var(--foreground))",
      "--normal-border": "hsl(var(--border))",
      "--border-radius": "var(--radius)"
    };
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== props || $[3] !== t1) {
    t4 = <Sonner theme={t1} className="toaster group" icons={t2} style={t3 as React.CSSProperties} {...props} />;
    $[2] = props;
    $[3] = t1;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function CrmToaster(props) {
  const $ = _c(14);
  const isMobile = useMobileSize();
  let t0;
  if ($[0] !== isMobile) {
    t0 = !isMobile && <style>{"\n          .toaster.group {\n            --toast-close-button-start: unset;\n            --toast-close-button-end: 0;\n            --toast-close-button-transform: translate(35%, -35%);\n          }\n        "}</style>;
    $[0] = isMobile;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = isMobile ? "bottom-center" : "top-center";
  const t2 = !isMobile;
  let t3;
  let t4;
  if ($[2] !== isMobile) {
    t3 = isMobile ? {
      bottom: 72
    } : {
      right: "var(--sonner-desktop-offset-right, 32px)"
    };
    t4 = isMobile ? {
      bottom: 72
    } : undefined;
    $[2] = isMobile;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== props || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
    t5 = <BaseToaster position={t1} closeButton={t2} offset={t3} mobileOffset={t4} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t0 || $[12] !== t5) {
    t6 = <>{t0}{t5}</>;
    $[11] = t0;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function Toaster(t0) {
  const $ = _c(6);
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      useCrmToastDefaults: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
  } else {
    props = $[1];
    t1 = $[2];
  }
  const useCrmToastDefaults = t1 === undefined ? false : t1;
  let t2;
  if ($[3] !== props || $[4] !== useCrmToastDefaults) {
    t2 = useCrmToastDefaults ? <CrmToaster {...props} /> : <BaseToaster {...props} />;
    $[3] = props;
    $[4] = useCrmToastDefaults;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export { Toaster, toast };